import { useContentResource, useImageResource } from "@ctv/core";
import { Image, TextSeo, ViewSeo } from "@ctv/shared-core/src";

import styles from "./FeatureList.module.css";

export default function FeatureList() {
  const cr = useContentResource().CorporateRevampFeaturesPage;
  const ir = useImageResource().CorporateRevampFeaturesPage;
  const accessRoleContents = [
    { title: cr.userAccessSubtitle1, content: cr.userAccessContent1 },
    { title: cr.userAccessSubtitle2, content: cr.userAccessContent2 },
  ];
  const approvalSystemContents = [
    { title: cr.approvalSystemSubtitle1, content: cr.approvalSystemContent1 },
    { title: cr.approvalSystemSubtitle2, content: cr.approvalSystemContent2 },
    { title: cr.approvalSystemSubtitle3, content: cr.approvalSystemContent3 },
  ];
  const travelPolicyContents = [
    { title: cr.travelPolicySubtitle1, content: cr.travelPolicyContent1 },
    { title: cr.travelPolicySubtitle2, content: cr.travelPolicyContent2 },
  ];
  const invoiceReportContents = [
    { title: cr.invoiceReportSubtitle1, content: cr.invoiceReportContent1 },
    { title: cr.invoiceReportSubtitle2, content: cr.invoiceReportContent2 },
  ];

  const features = [
    {
      img: ir.userAccessRole,
      title: cr.userAccessTitle,
      contents: accessRoleContents,
    },
    {
      img: ir.approvalSystem,
      title: cr.approvalSystemTitle,
      contents: approvalSystemContents,
    },
    {
      img: ir.travelPolicy,
      title: cr.travelPolicyTitle,
      contents: travelPolicyContents,
    },
    {
      img: ir.invoiceReport,
      title: cr.invoiceReportTitle,
      contents: invoiceReportContents,
    },
  ];

  return (
    <ViewSeo className={styles.container}>
      {features.map((feature, index) => (
        <ViewSeo key={index} className={styles.feature} spacing="xl">
          <Image
            className={styles.image}
            src={feature.img.link}
            alt={feature.img.altText}
            width={200}
            height={200}
          />
          <ViewSeo spacing="l">
            <TextSeo variant="headline">{feature.title}</TextSeo>
            {feature.contents.map((content, index) => (
              <ViewSeo key={index} spacing="xxs">
                <TextSeo variant="ui-baseline-bold">{content.title}</TextSeo>
                <TextSeo variant="ui-small" ink="black-secondary">
                  {content.content}
                </TextSeo>
              </ViewSeo>
            ))}
          </ViewSeo>
        </ViewSeo>
      ))}
    </ViewSeo>
  );
}
